import Teaser from './Teaser'
import SectionHero from './SectionHero'
import SectionCards from './SectionCards'
import Card from './Card'
import SectionImage from './SectionImage'
import HeaderMenu from './HeaderMenu'
import FooterMenu from './FooterMenu'
import TextColumn from './TextColumn'
import SectionArticles from './SectionArticles'
import HeaderSquares from './HeaderSquares'
import AppColumn from './AppColumn'
import AppRichtext from './AppRichtext'
import AppRow from './AppRow'
import AppSection from './AppSection'
import Button from './Button'
import CarouselSection from './CarouselSection'
import GallerySection from './GallerySection'
import PageHeader from './PageHeader'
import StoryList from './StoryList'

export default {
  Teaser,
  SectionHero,
  SectionCards,
  Card,
  SectionImage,
  FooterMenu,
  HeaderMenu,
  TextColumn,
  SectionArticles,
  HeaderSquares,
  AppColumn,
  AppRichtext,
  AppRow,
  AppSection,
  Button,
  CarouselSection,
  GallerySection,
  PageHeader,
  StoryList,
}
